var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64104 13.802C10.3088 13.802 13.2821 10.7567 13.2821 7.00015C13.2821 3.24356 10.3088 0.198242 6.64104 0.198242C2.9733 0.198242 0 3.24356 0 7.00015C0 10.7567 2.9733 13.802 6.64104 13.802Z",
    fill: "#FF060A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0686 5.67989C10.6481 5.28323 10.0662 4.67751 9.59225 4.24792L9.56422 4.22787C9.51767 4.18963 9.46493 4.15961 9.40866 4.13909C8.26589 3.92144 2.94789 2.90618 2.84414 2.91907C2.81508 2.92323 2.78728 2.93398 2.76283 2.95057L2.73617 2.97205C2.70338 3.00607 2.67847 3.04718 2.66327 3.09233L2.65625 3.11096V3.21261V3.22838C3.25495 4.93096 5.61885 10.5085 6.08434 11.8172C6.11239 11.9061 6.16565 12.0751 6.26521 12.0836H6.28763C6.34092 12.0836 6.56806 11.7772 6.56806 11.7772C6.56806 11.7772 10.6284 6.74813 11.0393 6.21257C11.0925 6.1466 11.1395 6.07564 11.1794 6.00065C11.1898 5.94198 11.1849 5.88159 11.1655 5.82536C11.1461 5.76916 11.1128 5.71903 11.0686 5.67989ZM7.60988 6.26555L9.34269 4.79779L10.3592 5.75436L7.60988 6.26555ZM6.93689 6.16962L3.95319 3.67229L8.78046 4.58158L6.93689 6.16962ZM7.20609 6.82402L10.2597 6.32142L6.76853 10.6174L7.20609 6.82402ZM3.54798 3.92144L6.68733 6.64216L6.23295 10.6201L3.54798 3.92144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrc);
export default __webpack_public_path__ + "static/media/trc.38f2ce1dc0a077769fa6e6577fa307a3.svg";
export { ForwardRef as ReactComponent };